// extracted by mini-css-extract-plugin
export var completionBody = "_c5-2";
export var completionCard = "_c5-0";
export var completionFooter = "_c5-3";
export var completionTitle = "_c5-1";